<template>
  <div class="kc-table">
    <div class="kc-crumbs">
      <router-link :to="address">{{courseName}}</router-link>
      <img src="../../assets/img/icon-more.png">
      <a href="javascript:;" class="kc-crumbs-state">{{detailobj.name}}</a>
    </div>

    <div class="kc-title">
      <el-image :src="detailobj.image" class="kc-cover"></el-image>
    	<div class="kc-title-right">
    		<div class="kc-title-right-title">
    			<!-- <span>{{detailobj.courseScore}}学分</span> -->{{detailobj.name}}
    		</div>
    		<div class="kc-title-jj">{{detailobj.teacherDesc}}</div>
    		<!-- <div class="kc-title-icon">
    			<img src="../../assets/img/icon-eye.png" class="kc-title-iconone"><span class="kc-title-icontwo">{{detailobj.watch}}</span>
    			<div style="display: inline-block;" @click="islike(detailobj)">
            <img style="cursor: pointer;" :src="detailobj.like == 0 ? imgurl0 : imgurl1 " class="kc-title-iconone">
            <span class="kc-title-icontwo">{{detailobj.likeCount}}</span>
          </div>
          <div style="display: inline-block;" @click="collection(detailobj)">
            <img  style="cursor: pointer;" :src="detailobj.collection == 0 ? imgurl2 : imgurl3" class="kc-title-iconone">
            <span class="feedback kc-title-icontwo">{{detailobj.collection == 0?'收藏':'取消收藏'}}</span>
          </div>
          <div style="display: inline-block;">
            <img style="margin-left: 20px;" src="../../assets/img/icon-feedback.png" class="kc-title-iconone">
            <span @click="tofeedback" class="feedback kc-title-icontwo">反馈</span>
          </div>

    		</div> -->
    	</div>
    </div>

    <div class="kc-content">
    	<div class="kc-content-left">
         <Detailcontent :content="detailobj.content"></Detailcontent>
      </div>
      <div class="kc-content-right">
         <Detailphone></Detailphone>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/css/coursedetail.css'
import Detailcontent from './child/Detailcontent.vue'
import Detailphone from './child/Detailphone.vue'
import {ApiGetBookCourseDetail, ApiCollect, ApiLike} from '../../net/course/index.js'
import {getCookie} from '../../untils/common.js'
export default {
  data: function () {
    return {
      str: '课程详情',
      lid : '',
      detailobj : {},
      chapter: [], //章节列表
      imgurl0 : require('../../assets/img/icon-heart.png'),
      imgurl1 : require('../../assets/img/icon-heart1.png'),
      imgurl2 : require('../../assets/img/icon-collection.png'),
      imgurl3 : require('../../assets/img/icon-collection1.png'),
      courseName : '',
      address :''
    }
  },
  components: {
    Detailphone,
    Detailcontent
  },
  methods:{
    getdetail(){
      const param = {id : this.lid}
      ApiGetBookCourseDetail(param).then(res=>{
        if(res.code == 200){
          this.detailobj = res.value
        }
      }).catch(err=>{

      })
    },
    tofeedback(){
      this.$router.push({
        path:'Feedback',
        query:{id : this.lid,courseName :this.detailobj.name, type: 'bookCourse'},
      })
    },
    collection(item){
      const param = {
        courseId : this.lid,
        status : item.collection == 0 ? '1':'2'
      }
      ApiCollect(param).then(res => {
        if(res.code == 200){
          if(item.collection == 0){
            this.detailobj.collection = 1;
          }else{
            this.detailobj.collection = 0;
          }
        }
      })
    },
    islike(item){
      const param = {
        courseId : this.lid,
        status : item.like == 0 ? '1':'2'
      }
      ApiLike(param).then(res => {
        if(res.code == 200){
          if(item.like == 0){
            this.detailobj.like = 1;
            this.detailobj.likeCount += 1;
          }else{
            this.detailobj.like = 0;
            this.detailobj.likeCount -= 1;
          }
        }
      })
    }
  },
  created() {
    this.lid = this.$route.query.id;
  },
  mounted() {
    switch (getCookie('frompage')){
      case 'AllCourse':
      this.courseName = '全部课程'
      this.address = '/AllCourse'
      break
      case 'BookCourse':
      this.courseName = '电子书'
      this.address = '/BookCourse'
      break
      case 'ICourse':
      this.courseName = '重点课程'
      this.address = '/ICourse'
      break
      case 'PlanDetail':
      this.courseName = '任务详情'
      this.address = '/PlanDetail?id=' + getCookie('plid')
      break
      case 'home':
      this.courseName = '首页'
      this.address = '/'
      break
    }

   this.getdetail();
   this.$store.commit('afterEach')
  },
}
</script>

<style scoped>
  .feedback{
    cursor: pointer;
  }
  .feedback:hover{
    color:  #0AAC50;;
  }
  .kc-crumbs{
  	width: 1140px;
  	margin: 0 auto;
  	margin-top: 20px;
  	margin-bottom: 20px;
  	overflow: hidden;
  }
  .kc-crumbs a{
  	font-size: 16px;
  	color: #7f7f7f;
  	text-decoration: none;
  	float: left;
  }
  .kc-crumbs img{
  	width: 16px;
  	height: 16px;
  	float: left;
  	margin-top: 4px;
  	margin-left: 2px;
  	margin-right: 2px;
  }
  .kc-crumbs a.kc-crumbs-state{
  	color: #252525;
  }
  .kc-crumbs a:hover{
  	color: #0AAC50;
  }
</style>



// WEBPACK FOOTER //
// src/components/BookCourseDetail/BookCourseDetail.vue